<template>
    <div v-if="null != settlementDetails">
        <restaurant-settlement-details
            v-bind:settlementDetails="settlementDetails"
            v-on:date-change="onSettlementDetailDateChange"
        />
        <v-container fluid>
            <v-row justify="start">
                <v-col cols="12" md="6">
                    <settlement-pending-list
                        v-bind:pendingSettlements="pendingSettlements"
                        v-on:request-set-date="onSettlementDetailDateChange"
                    />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import restaurantApi from '@/api/restaurantApi';
import store from '@/store/';

export default {
    components: {
        'restaurant-settlement-details': () =>
            import('@/components/RestaurantSettlementDetails.vue'),
        'settlement-pending-list': () =>
            import('@/components/SettlementPendingList.vue')
    },
    data() {
        return {
            settlementDetails: null,
            pendingSettlements: []
        };
    },
    async beforeRouteEnter(to, from, next) {
        const restaurantId = store.state.auth.user.restaurant.id;
        const response = await restaurantApi.getSettlementDetails(
            restaurantId,
            new Date(),
            true // include pending settlements list
        );
        next(vm => vm.setData(response.data));
    },
    methods: {
        setData(data) {
            this.settlementDetails = data.settlement_details;
            this.pendingSettlements = data.pending_settlements;
        },
        async onSettlementDetailDateChange(date) {
            const restaurantId = store.state.auth.user.restaurant.id;
            const response = await restaurantApi.getSettlementDetails(
                restaurantId,
                date
            );
            this.settlementDetails = response.data.settlement_details;
        }
    }
};
</script>
